const comments = [
  {
    name: '影迷小明',
    avatar: 'M',
    text: '用了好多影视站，鲁鲁影院是体验最好的！画质清晰不卡顿，而且真的没有广告弹窗，追剧体验太棒了。推荐给身边所有朋友了！',
    stars: 5,
    time: '3天前',
  },
  {
    name: '追剧达人小雅',
    avatar: 'Y',
    text: '更新速度真的快，每周最期待的剧集都能第一时间看到。手机上看也很流畅，午休时间追一集刚刚好。强烈推荐！',
    stars: 5,
    time: '5天前',
  },
  {
    name: '电影爱好者老张',
    avatar: 'Z',
    text: '片源很全，从老片到新片基本都能找到。最让我惊喜的是分类做得很细致，发现了好多之前错过的冷门好片。高清画质在大屏上看特别爽！',
    stars: 4,
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            用户评价
          </h2>
          <p className="mt-2 text-sm text-foreground-500">来自真实用户的使用感受</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, si) => (
                  <i
                    key={si}
                    className={`text-sm ${
                      si < comment.stars
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-fill text-background-300'
                    }`}
                  ></i>
                ))}
              </div>

              {/* Text */}
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{comment.text}&rdquo;
              </p>

              {/* User info */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}